import type { ReactNode } from "react";
import "../../../styles/actionbar/item.css";

export { Img };
type Props = {
  className?: string;
  children: ReactNode;
};

const Img = (props: Props) => {
  return (
    <div className={`actionBarItem img ${props.className ?? ""}`}>
      {/* <span> */}
      {props.children}
      {/* </span> */}
    </div>
  );
};
